import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["error", "finished"]
  static values = { interval: { type: Number, default: 30000 } }

  connect() {
    this.dirty = false
    this.timer = setInterval(() => this.refresh(), Math.max(1000, this.intervalValue))
  }

  disconnect() {
    clearInterval(this.timer)
  }

  edited() { this.dirty = true }

  loaded() {
    this.dirty = false
    if (this.hasErrorTarget) this.errorTarget.classList.add("d-none")
    if (this.hasFinishedTarget) clearInterval(this.timer)
  }

  failed() {
    if (this.hasErrorTarget) this.errorTarget.classList.remove("d-none")
  }

  refresh() {
    const focused = document.activeElement
    if (document.hidden || this.dirty || this.element.hasAttribute("busy") ||
        document.querySelector("dialog[open]") ||
        (this.element.contains(focused) && focused.closest("form"))) return

    if (this.element.src === window.location.href) this.element.reload()
    else this.element.src = window.location.href
  }
}
